import { render, staticRenderFns } from "./equipmentList.vue?vue&type=template&id=3b8c54f4&scoped=true&"
import script from "./equipmentList.vue?vue&type=script&lang=js&"
export * from "./equipmentList.vue?vue&type=script&lang=js&"
import style0 from "./equipmentList.vue?vue&type=style&index=0&id=3b8c54f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c54f4",
  null
  
)

export default component.exports